import { RootStore } from "./RootStore";
import { observable, action } from "mobx";

export class GeneralStore {
  protected rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    const matchMediaEvent = window.matchMedia("(max-width: 700px)");

    this.setMobileSize(matchMediaEvent);
    matchMediaEvent.addListener(this.setMobileSize);

    if (this.mobileSize) {
      this.isDrawerOpen = false;
    }
  }

  @observable public mobileSize = false;
  @observable public isDrawerOpen = true;
  @observable public showLoading = false;
  @observable public snackbar: {
    msg: string;
    variant: "success" | "info" | "warning" | "error";
  } | null = null;

  @action
  private setMobileSize = (e: any) => {
    if (e.matches) {
      this.mobileSize = true;
    } else {
      this.mobileSize = false;
    }
  };

  @action
  public showSnackbar = (
    msg: string,
    variant: "success" | "info" | "warning" | "error"
  ) => {
    this.snackbar = { msg, variant };
  };

  @action
  public closeSnackbar = () => {
    this.snackbar = null;
  };

  @action
  public setShowLoading = (bool: boolean) => {
    this.showLoading = bool;
  };

  @action
  public handleDrawerOpen = () => {
    this.isDrawerOpen = true;
  };

  @action
  public handleDrawerClose = () => {
    this.isDrawerOpen = false;
  };

  @action
  public handleDrawer = () => {
    this.isDrawerOpen = !this.isDrawerOpen;
  };
}
